export const RC_CLIENT_ID = process.env.REACT_APP_RC_PHONE_CLIENT_ID;
export const RC_SERVER_URL =
  process.env.REACT_APP_RC_SERVER_URL || 'https://platform.ringcentral.com';
export const RC_REDIRECT_URI =
  process.env.REACT_APP_RC_REDIRECT_URI ||
  `${window.location.origin}/rc-callback`;
export const RC_FROM_NUMBER = process.env.REACT_APP_RC_FROM_PHONE_NUMBER || '';

export const APP_NAME = 'VeritasRatings';
export const APP_VERSION = '1.0.0';

export const STORAGE_KEYS = {
  tokens: 'rc_tokens',
  pkceVerifier: 'rc_pkce_verifier',
  pendingNumber: 'rc_pending_number',
  returnPath: 'rc_return_path',
  // Set while an RC sign-in POPUP is in flight: the callback page closes
  // itself instead of navigating (the opener keeps its state/drafts).
  popupLogin: 'rc_popup_login',
};
